import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export function NotFound(): JSX.Element {
  const { t } = useTranslation();
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 py-24 text-center">
      <h1 className="text-3xl font-semibold">404</h1>
      <p className="text-muted-foreground">{t('notFound.doesNotExist')}</p>
      <Button asChild>
        <Link to="/">{t('notFound.backToOverview')}</Link>
      </Button>
    </div>
  );
}
